
const font = 'Helvetica';
const fontBold = 'Helvetica-Bold';
// const font = 'Calibri';
// const fontBold = 'Calibri-Bold';

const styles: any = {
    page: {
        fontFamily: font,
        padding: '100pt 60pt 60pt 60pt',
        fontSize: '11pt',
        display: 'flex',
        flexDirection: 'column'
    },
    katalog_l1: {
        fontSize: '12pt',
        fontFamily: fontBold,
        marginBottom: '5pt',
        display: 'flex',
        flexDirection: 'row'
    },
    katalog_l2: {
        fontSize: '11pt',
        marginBottom: '5pt',
        display: 'flex',
        flexDirection: 'row'
    },
    h1: {
        fontFamily: fontBold,
        fontSize: '16pt',
        fontWeight: 'bold',
        marginTop: '12pt',
        marginBottom: '3pt'
    },
    h2: {
        fontFamily: fontBold,
        fontSize: '12pt',
        fontWeight: 'bold',
        color: '#728a49',
        marginTop: '12pt',
        marginBottom: '3pt'
    },
    div: {
        marginBottom: '8pt',
        wordBreak: 'break-word'
    },
    list: {
        marginLeft: '20pt'
    },
    list_number: {
        width: '20pt',
        minWidth: '20pt'
    },
    list_alphabet: {
        width: '20pt',
        minWidth: '20pt',
        fontWeight: 'bold',
        fontFamily: fontBold
    },
    bold: {
        fontWeight: 'bold',
        fontFamily: fontBold
    },
    deckblattTitle: {
        zIndex: 100,
        position: 'absolute',
        left: '50pt',
        top: '190pt',
        fontSize: '30pt',
        color: '#444'
    },
    deckblattTitleFirmenname: {
        fontFamily: fontBold,
        fontWeight: 'bold',
        lineHeight: 1,
        fontSize: '23pt',
        width: '500pt',
        height: '50pt'
    },
    deckblattLogo: {
        zIndex: 100,
        position: 'absolute',
        left: '60pt',
        bottom: '45pt',
        width: 'auto',
        height: '60pt',
    },
    header: {
        position: 'absolute',
        width: '100%',
        top: '30pt',
        left: '60pt',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: '1pt solid #000',
        fontSize: '14pt',
        color: '#728a49',
        fontFamily: fontBold
    },
    headerLogo: {
        width: 'auto',
        height: '35pt',
        marginLeft: '10pt'
    },
    footer: {
        position: 'absolute',
        width: '100%',
        bottom: '25pt',
        left: '60pt',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderTop: '1pt solid #000',
        paddingTop: '8pt'
    }
};

export function getStyle(key: string, pdf = true): any {
    const style = { ...styles[key] || {} };
    if (!pdf) {
        delete style.fontFamily;
    }
    return style;
}
